module.exports = __webpack_public_path__ + "static/media/bottom_infographic_desktop.9aa27405.webp";